import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetSeoUrlsLoading, EGetSeoUrlsActionType } from './types';

export const getSeoUrlsLoading: () => TGetSeoUrlsLoading = actionGenerator<EGetSeoUrlsActionType.Loading>(
  EGetSeoUrlsActionType.Loading,
);
